import * as yup from 'yup';

export const schema = yup.object({
  iconId: yup.lazy((value) => {
    if (typeof value === 'string') {
      return yup.string().min(5, 'Avatar is required').required('Avatar is required');
    }

    return yup.mixed().required('Avatar is required');
  }),
  name: yup.string().max(128, 'Name must be at most 128 characters').required('Name is required'),
  email: yup
    .string()
    .email('Email must be a valid email address')
    .max(35, 'Email must be at most 35 characters')
    .required('Email is required'),
  surname: yup.string().max(128, 'Surname must be at most 128 characters').required('Surname is required'),
  username: yup.string().max(128, 'Username must be at most 128 characters').required('Username is required'),
});
